import React from "react";

import { InsuredGoodDetailPage, InsuredGoodPage, InsuredGoodSearchPage } from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, Identity, Permissions, RouteItem } from "@/shared/domain";

export const insuredGoodsRoutes = (user: Identity): RouteItem[] => {
    return [
        {
            path: AppRoute.InsuredGoods,
            element: <InsuredGoodPage />,
            breadcrumb: fakeI18n.t("Breadcrumbs.InsuredGoods"),
        },
        {
            path: AppRoute.InsuredGoodsSearch,
            element: <InsuredGoodSearchPage />,
            breadcrumb: fakeI18n.t("Common.Search"),
        },
        ...(user.hasGlobalPermission(Permissions.ViewRisksDetails)
            ? [
                  {
                      path: AppRoute.InsuredGoodDetails,
                      element: <InsuredGoodDetailPage />,
                  },
              ]
            : []),
    ];
};
